export default "__VITE_ASSET__DXTKiO1N__"